export default {
  autoSaveInstruction: {
    en: "Just type. Notes auto-save.",
  },
};
